export default () => {
    return {
        trabajosContables: [],
        trabajosContablesListener: null,
        numerosContables: {},
        //codigoRestaurante: ''
    }
}

